import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import configureStore from '../helpers/configureStore';
import schoolEntry from '../reducers/school_entry';
import saga from '../sagas/schoolEntrySaga';
import Steps from '../components/school_entry/Steps';

const store = configureStore({ schoolEntry }, saga);
const targetNode = document.getElementById('steps');
createRoot(targetNode).render(
  <Provider store={store}>
    <Steps
      current={targetNode.getAttribute('data-current')}
      loggedIn={targetNode.getAttribute('data-logged-in') === 'true'}
      stripeEnabled={targetNode.getAttribute('data-stripe-enabled') === 'true'}
    />
  </Provider>
);
